<template>
  <el-tabs type="border-card" v-model="activeName" stretch>
    <el-tab-pane label="基本信息" name="jbxx">
      <el-form ref="form1" :model="form1" :rules="form1Rules" label-width="80px" :disabled="readonly">
        <el-row>
          <el-col :lg="12" :xs="24">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form1.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="会员类别" prop="user_type2">
              <el-select
                v-model="form1.user_type2"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.perMemberClass"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :lg="12" :xs="24">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form1.sex" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in optionsDict.gender" :key="item.id" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="民族" prop="national">
              <el-select v-model="form1.national" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in optionsDict.nation" :key="item.id" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker v-model="form1.birthday" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
                placeholder="选择日期" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="籍贯" prop="birthplace">
              <el-cascader style="width: 100%" v-model="form1.birthplace" v-if="hasLoadBirthplace"
                :options="areaOptions" :props="birthplaceProps"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="学历" prop="education">
              <el-select v-model="form1.education" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in optionsDict.education" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="政治面貌" prop="political">
              <el-select v-model="form1.political" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in optionsDict.political" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="身份证件" prop="card_type">
              <el-select v-model="form1.card_type" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in optionsDict.identification" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="24" :xs="24">
            <el-form-item label="证件号码" prop="id_no">
              <el-input v-model="form1.id_no" placeholder="请输入证件号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="24" :xs="24">
            <el-form-item label="头像" prop="icon" error="请上传1寸蓝底、红底或白底标准照">
              <el-upload class="avatar-uploader" ref="upload" action="" :limit="1"
                :on-preview="handlePictureCardPreview" :on-change="handleChange" :on-remove="handleRemove"
                :file-list="fileList" :auto-upload="false">
                <img v-if="form1.icon && form1.icon.length > 0" slot="trigger" width="100%" style="max-width: 200px;" :src="form1.icon" alt="" />
                <el-button else slot="trigger" size="small" type="primary">上传头像</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center" v-if="!readonly">
        <el-button type="warning" @click="jbxxSubmit()">下一步</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="联系方式" name="lxfs">
      <el-form ref="form2" :model="form2" :rules="form2Rules" label-width="80px" :disabled="readonly">
        <el-row>
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="座机" prop="landline">
              <el-input
                v-model="form2.landline"
                placeholder="请输入座机"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :lg="12" :xs="24">
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="form2.email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="手机" prop="wechat">
              <el-input v-model="form2.wechat" placeholder="请输入手机"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="QQ" prop="qq">
              <el-input v-model="form2.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="抖音" prop="douyin_id">
              <el-input
                v-model="form2.douyin_id"
                placeholder="请输入抖音"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="视频号" prop="video_id">
              <el-input
                v-model="form2.video_id"
                placeholder="请输入视频号"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :lg="24" :xs="24">
            <el-form-item label="收件地址" prop="area">
              <el-cascader v-if="hasLoadArea" style="width: 100%" v-model="form2.area" :options="areaOptions"
                :props="areaProps"></el-cascader>
            </el-form-item>
            <el-form-item label=" " required prop="address" error="请确认该地址信息为本人有效收件地址">
              <el-input v-model="form2.address" type="textarea" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">

          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center" v-if="!readonly">
        <el-button type="warning" @click="lxfsSubmit()">下一步</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="职业信息" name="zyxx">
      <el-form ref="form3" :model="form3" :rules="form3Rules" label-position="top" :disabled="readonly">
        <el-row>
          <el-col :span="24">
            <el-form-item label="工作单位" prop="job_address">
              <el-input v-model="form3.job_address" placeholder="请输入工作单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="职务" prop="role">
              <el-input v-model="form3.role" placeholder="请输入职务"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="职称" prop="technical">
              <el-checkbox-group v-model="form3.technical">
                <el-input v-model="form3.technical" placeholder="请输入职称，没有请填无"></el-input>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="称号" prop="honor">
              <el-checkbox-group v-model="form3.honor">
                <el-checkbox v-for="item in optionsDict.honor" :label="item.label" :value="item.value" name="type"
                  :key="item.id"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="擅长领域" prop="skill2">
              <el-checkbox-group v-model="form3.skill2">
                <el-checkbox v-for="item in optionsDict.beGoodAtFields" :label="item.label" :value="item.value"
                  name="type" :key="item.id"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop="skill">
              <el-input type="textarea" v-model="form3.skill" placeholder="请输入擅长领域"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作经历及艺术成就" prop="achievements">

              <el-upload ref="upload" action="" :limit="1" accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf" :on-change="handleJobFileChange"
                :on-remove="handleJobFileRemove" :file-list="jobFileList" :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                <br />
                <el-link type="primary" v-if="form3.job_file && form3.job_file.length > 0" :href="'http://huiyuan.caefa.org/' + form3.job_file" target="_blank" >已上传，点击查看</el-link>
                <div slot="tip" class="el-upload__tip">请上传Word/PDF格式的文件</div>
              </el-upload>
              <!-- 
              <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                :mode="mode" />
              <Editor style="height: 500px; overflow-y: hidden" v-model="form3.achievements"
                :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" /> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center" v-if="!readonly">
        <el-button type="warning" @click="zyxxSubmit()">下一步</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="推荐人" name="tjr">
      <el-form ref="form4" :model="form4" :rules="form4Rules" label-position="top" :disabled="readonly">
        <el-row>
          <el-col :span="24" style="padding: 10px 0;">
            <el-checkbox v-model="nobody" @change="nobodyChange">无推荐人</el-checkbox>
          </el-col>
          <el-col :span="24">
            <el-form-item label="姓名" prop="tj_name">
              <el-input v-model="form4.tj_name" :disabled="!form4Rules.tj_name[0]['required']" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作单位" prop="tj_job">
              <el-input v-model="form4.tj_job" :disabled="!form4Rules.tj_job[0]['required']" placeholder="请输入工作单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号码" prop="tj_phone">
              <el-input v-model="form4.tj_phone" :disabled="!form4Rules.tj_phone[0]['required']" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="职称或称号" prop="tj_technical">
              <el-input v-model="form4.tj_technical" :disabled="!form4Rules.tj_technical[0]['required']" placeholder="请输入职称或称号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="register-btn-center" v-if="!readonly">
          <el-button type="warning" @click="tjrSubmit()">提交</el-button>
        </div>
      </el-form>
    </el-tab-pane>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="form1.icon" alt="" />
    </el-dialog>
  </el-tabs>
</template>

<script>
import { request } from "@/api/service";
import cookies from "@/libs/util.cookies";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: 0,
      activeName: "jbxx",
      optionsDict: {
        gender: [],
        nation: [],
        education: [],
        political: [],
        identification: [],
        technical: [],
        honor: [],
        beGoodAtFields: [],
        perMemberClass: [],
      },
      areaOptions: null,
      birthplaceOptions: null,
      areaProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          console.log(22222222);
          console.log(node);
          let url = "/api/system/getArea?limit=999&page=1&level=1";
          if (node && node.value) {
            url = "/api/system/getArea?limit=999&pcode=" + node.value;
          }
          request({
            url: url,
            method: "get",
          }).then((response) => {
            const nodes = response.data.data.map((item) => ({
              value: item.code,
              label: item.name,
              leaf: item.level > 2,
            }));
            console.log(nodes);
            resolve(nodes);
          });
        },
      },
      birthplaceProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          let url = "/api/system/getArea?limit=999&page=1&level=1";
          if (node && node.value) {
            url = "/api/system/getArea?limit=999&pcode=" + node.value;
          }
          request({
            url: url,
            method: "get",
          }).then((response) => {
            const nodes = response.data.data.map((item) => ({
              value: item.code,
              label: item.name,
              leaf: item.level >= 2,
            }));
            console.log(nodes);
            resolve(nodes);
          });
        },
      },
      form1: {
        name: "",
        icon: "",
        user_type2: "个人会员",
        sex: "",
        national: "",
        birthday: "1970-01-01",
        birthplace: "",
        education: "",
        political: "",
        card_type: "",
        id_no: "",
      },
      form1Rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 4, message: "长度在 2 到 4 个字符", trigger: "blur" },
        ],
        icon: [{ required: true, message: "请上传1寸蓝底、红底或白底标准照", trigger: "blur" }],
        pen_name: [{ required: true, message: "请输入笔名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        national: [{ required: true, message: "请选择民族", trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        birthplace: [
          { required: true, message: "请选择出生地", trigger: "blur" },
        ],
        education: [{ required: true, message: "请选择学历", trigger: "blur" }],
        political: [
          { required: true, message: "请选择政治面貌", trigger: "blur" },
        ],
        card_type: [
          { required: true, message: "请选择身份证件", trigger: "blur" },
        ],
        id_no: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { min: 18, max: 18, message: "请输入正确的身份证号码" },
        ],
      },
      form2: {
        landline: "",
        email: "",
        wechat: "",
        qq: "",
        douyin_id: "",
        video_id: "",
        area: [],
        address: "",
      },
      form2Rules: {
        landline: [
          { required: true, message: "请输入固定电话", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        wechat: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const phoneRegex = /^1[3-9]\d{9}$/;
              if (phoneRegex.test(value)) {
                return callback();
              } else {
                return callback(new Error("手机号格式不正确"));
              }
            },
            trigger: "blur",
          }
        ],
        qq: [
          { required: true, message: "请输入QQ号", trigger: "blur" },
          { min: 4, max: 20, message: "请输入正确的QQ号" },
        ],
        douyin_id: [
          { required: true, message: "请输入抖音号", trigger: "blur" },
          { min: 4, max: 20, message: "请输入正确的抖音号" },
        ],
        video_id: [
          { required: true, message: "请输入视频号", trigger: "blur" },
          { min: 4, max: 20, message: "请输入正确的视频号" },
        ],
        area: [
          { required: true, message: "请输入收件地址", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      form3: {
        job_address: "",
        role: "",
        technical: [],
        honor: [],
        skill: "",
        skill2: [],
        achievements: "",
        job_file: ""
      },
      form3Rules: {
        job_address: [
          { required: true, message: "请输入工作地址", trigger: "blur" },
          { min: 1, max: 100, message: "请输入正确的工作地址" },
        ],
        role: [
          { required: true, message: "请输入角色", trigger: "blur" },
          { min: 1, max: 20, message: "请输入正确的角色" },
        ],
        technical: [{ required: true, message: "请输入职称", trigger: "blur" }],
        honor: [{ required: true, message: "请输入称号", trigger: "blur" }],
        skill: [],
        skill2: [],
        achievements: [],
      },
      form4: {
        tj_name: "",
        tj_job: "",
        tj_phone: "",
        tj_technical: "",
      },
      nobody: false,
      form4Rules: {
        tj_name: [
          { required: true, message: "请输入推荐人姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" },
        ],
        tj_job: [
          { required: true, message: "请输入推荐人职位", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 4 个字符", trigger: "blur" },
        ],
        tj_phone: [
          { required: true, message: "请输入推荐人手机号码", trigger: "blur" },
        ],
        tj_technical: [
          { required: true, message: "请输入职称 称号", trigger: "blur" },
        ],
      },
      editor: null,
      toolbarConfig: {
        toolbarKeys: [
          "blockquote",
          "header1",
          "header2",
          "header3",
          "|",
          "bold",
          "underline",
          "italic",
          "through",
          "color",
          "bgColor",
          "clearStyle",
          "|",
          "bulletedList",
          "numberedList",
          "todo",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "|",
          "insertLink",
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage"],
          },
          "insertVideo",
          "insertTable",
          "codeBlock",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
      },
      editorConfig: { placeholder: "请输入内容..." },
      mode: "simple", // or 'default'
      dialogVisible: false,
      fileList: [],
      jobFileList: [],
      hasLoadBirthplace: false,
      hasLoadArea: false,
    };
  },
  mounted() {
    this.getUserInfoFun();
    this.getDictFun();
    this.refreshUI();
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    refreshUI() {
      this.$nextTick(() => {
        var self = this;
        this.birthplaceProps.lazyLoad(null, (children) => {
          console.log('强制加载1');
          self.hasLoadBirthplace = true;
        });
        this.areaProps.lazyLoad(null, (children) => {
          console.log('强制加载2');
          self.hasLoadArea = true;
        });

      });
    },
    handleJobFileChange(file, fileList) {
      if (file) {

        const formData = new FormData()
        formData.append('file', fileList[0].raw)  // 文件字段

        request({
          url: "/api/system/file/",
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log(res);
          if (res.code === 2000) {
            this.form3.job_file = res.data.file_url
          }
        })
      }
      this.jobFileList = [file];
    },
    handleJobFileRemove(file, fileList) {
      this.form3.job_file = "";
      this.jobFileList = [];
    },
    handleRemove(file, fileList) {
      this.form1.icon = "";
      this.fileList = [];
    },
    handleChange(file, fileList) {
      if (file) {
        const reader = new FileReader();
        var self = this;
        reader.onload = function (e) {
          const base64String = e.target.result;
          self.form1.icon = base64String;
        };
        reader.readAsDataURL(file.raw);
      }
      this.fileList = [file];
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
    },
    nobodyChange(e) {
      for (const key in this.form4Rules) {
        this.form4Rules[key][0]['required'] = !e
      }
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    getDictFun() {
      var self = this;
      request({
        url: "/app/getDictionary",
        method: "post",
        data: {
          keys: [
            "gender", // 性别
            "nation", // 民族
            "education", // 学历
            "political", // 政治面貌
            "identification", // 身份证件
            "technical", // 技术职称
            "honor", // 称号
            "beGoodAtFields", // 擅长领域
            "perMemberClass",
          ],
        },
      }).then((res) => {
        if (res.code == 2000) {
          self.optionsDict = res.data ? res.data : {};
        }
      });
    },
    getUserInfoFun() {
      var self = this;
      request({
        url: "/app/getUserInfo",
        method: "post",
        data: {
          user_type: "个人会员",
        },
      }).then((res) => {
        if (res.code == 2000) {
          for (const key in self.form1) {
            if (res.data[key]) {
              self.form1[key] = res.data[key];
            }
          }
          for (const key in self.form2) {
            if (res.data[key]) {
              self.form2[key] = res.data[key];
            }
          }
          for (const key in self.form3) {
            if (res.data[key]) {
              self.form3[key] = res.data[key];
            }
          }
          for (const key in self.form4) {
            if (res.data[key]) {
              self.form4[key] = res.data[key];
            }
          }
          self.form1.sex = res.data.sex + "";
          self.form2.area = JSON.parse(res.data.area);
          self.form3.honor = res.data.honor ? JSON.parse(res.data.honor) : [];
          self.form3.skill2 = res.data.skill2
            ? JSON.parse(res.data.skill2)
            : [];
          self.form1.birthplace = res.data.birthplace
            ? JSON.parse(res.data.birthplace)
            : [];
          if (!res.data.name) {
            self.hasLoadBirthplace = true;
            self.hasLoadArea = true;
          }
        }
      });
    },
    jbxxSubmit() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.activeName = "lxfs";
          console.log(this.form1);
        }
      });
    },
    lxfsSubmit() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.activeName = "zyxx";
          console.log(this.form2);
        }
      });
      this.refreshUI();
    },
    zyxxSubmit() {
      this.$refs.form3.validate((valid) => {
        if (valid) {
          this.activeName = "tjr";
          console.log(this.form3);
        }
      });
    },
    tjrSubmit() {
      this.$refs.form4.validate((valid) => {
        if (valid) {
          var self = this;
          let data = {
            ...this.form1,
            ...this.form2,
            ...this.form3,
            ...this.form4,
            area: JSON.stringify(this.form2.area),
            honor: JSON.stringify(this.form3.honor),
            skill2: JSON.stringify(this.form3.skill2),
            birthplace: JSON.stringify(this.form1.birthplace),
            user_type: "个人会员",
          };
          request({
            url: "/app/updateUserInfo",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.code == 2000) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              cookies.set("name", self.form1.name);
              window.location.reload();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.register-btn-center {
  margin: 40px auto;
  display: grid;
  place-items: center;
}

.tag-box {
  margin: 0 20px 20px 0;
  cursor: pointer;
  /* 标准语法，适用于现代浏览器 */
  user-select: none;
  /* 火狐浏览器 */
  -moz-user-select: none;
  /* 谷歌、Safari 等浏览器 */
  -webkit-user-select: none;
  /* IE 10+ */
  -ms-user-select: none;
}
</style>